import HomepageFinalCta from './HomepageFinalCta'
import HomepageFitSection from './HomepageFitSection'
import HomepageHero from './HomepageHero'
import HomepagePathsSection from './HomepagePathsSection'
import HomepageTestimonials from './HomepageTestimonials'
import HomepageTrustBar from './HomepageTrustBar'

function HomePageV2({ reviews = [] }) {
    return (
        <>
            <HomepageHero />
            <HomepageTrustBar />
            <HomepageFitSection />
            <HomepagePathsSection />
            <HomepageTestimonials reviews={reviews} />
            <HomepageFinalCta />
        </>
    )
}

export default HomePageV2
